var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcKakaoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/16/Line/Black/Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M12.4606 4.74219L5.62136 11.7799L3.71895 11.5624L3.50446 9.57592L10.3312 2.55101L12.4606 4.74219ZM5.67864 11.7865C5.67871 11.7865 5.67879 11.7865 5.67886 11.7865L5.67864 11.7865Z",
    stroke: "#2E2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 3,
    y: 13,
    width: 10,
    height: 1,
    rx: 0.4,
    fill: "#2E2E30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKakaoEdit);
export default __webpack_public_path__ + "static/media/ic_kakao_edit.e91de308a4021ae9120c1c78342106c7.svg";
export { ForwardRef as ReactComponent };